type CartesianPosition = 'left' | 'right' | 'top' | 'bottom';

const OFFSET = 60;

const defaultLeftYAxisIds = ['level', 'angle', 'voltage'];

export const generateYAxisPositions = (
  yAxisPositions: {
    id: string;
    position?: CartesianPosition | undefined | null;
    gridIndex: number;
  }[],
  includedSeries: string[],
): { position: CartesianPosition; offset: number }[] => {
  const recurrencePerGridIndex = new Map<number, Record<string, number>>([
    [0, { left: 0, right: 0 }],
  ]);

  return yAxisPositions.map((yAxisPosition) => {
    if (!includedSeries.includes(yAxisPosition.id)) return { position: 'right', offset: 0 };
    const gridIndex = yAxisPosition.gridIndex;
    if (!recurrencePerGridIndex.has(gridIndex)) {
      recurrencePerGridIndex.set(gridIndex, { left: 0, right: 0 });
    }
    const recurrence = recurrencePerGridIndex.get(gridIndex)!;
    if (yAxisPosition.position) {
      return {
        position: yAxisPosition.position,
        offset: recurrence[yAxisPosition.position]++ * OFFSET,
      };
    } else {
      const position = defaultLeftYAxisIds.find((leftId) => leftId === yAxisPosition.id)
        ? 'left'
        : 'right';
      return {
        position,
        offset: recurrence[position]++ * OFFSET,
      };
    }
  });
};
